import { render, staticRenderFns } from "./AreaConhecimento.vue?vue&type=template&id=9718a89c&"
import script from "./AreaConhecimento.vue?vue&type=script&lang=js&"
export * from "./AreaConhecimento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports